var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-app gs-self-billing-page"},[_c('div',{staticClass:"gs-self-billing-page__content"},[_c('v-wait',{attrs:{"for":"dashboard"}},[_c('div',{staticClass:"gs-self-billing-page__state"},[_vm._v(" "+_vm._s(_vm.$t('frontend_coming_soon'))+" ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }